import { Component, EventEmitter, Inject, Input, OnInit, OnDestroy, Output, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { validateIBAN } from '@commons';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { CupsPTData, GenericResponse, Mobile, Select } from '@interfaces';
import { NewContractPymesService } from 'src/app/services/new-contract-pymes.service';
import { UtilService } from 'src/app/services/util.service';
import {
  SavedDataMultipoint,
  InstallationMultiPoint,
  InstallationsMultiPoint,
  ErrorsServices,
  ListCups,
  CheckCups,
  ListPostalCode
} from '../../new-contract-pymes-multipoint.model';
import { NewContractPymesMultipointService } from '../../new-contract-pymes-multipoint.service';
import { MyErrorStateMatcher } from '../../custom-error-matcher';
import { concat, Observable, Subject } from 'rxjs';
import { last, takeUntil, tap } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MultipointModalErrorEndpointsComponent } from '../multipoint-modal-error-endpoints/multipoint-modal-error-endpoints.component';
import { UtilValidatorsService } from 'src/app/commons/validations-format/util-validators.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from 'src/app/auth';
import { Cycle, Period, Tension, Tensions } from 'src/app/modules/new-contract-pymes/new-contract-pymes.model';

const installationForm = {
  groupIndex: null,
  name: [ { value: '', disabled: false }, [ Validators.required, Validators.maxLength(40) ] ],
  cups: [ { value: '', disabled: false } ],
  cnae: null,
  fee: [ { value: '', disabled: true } ],
  feeReal: [ { value: null, disabled: true } ],
  geographicZone: null,
  tension: [ { value: null, disabled: true } ],
  cycle: [ { value: null, disabled: true } ],
  period: [ { value: null, disabled: true } ],
  potency: [ { value: null, disabled: true } ],
  customPotency: [ { value: null, disabled: true } ],
  cuPsAcepptedCRM: false,
  codErrorAcepptedCRM: null,
  descriptionErrorAcepptedCRM: null,
  codInstallation: null,
  sendedCRM: false,
  registeredCRM: false,
  codErrorRegisteredCRM: null,
  descriptionErrorRegisteredCRM: null,
  estimatedConsumptionPeriod: null,
  contractedPowerPeriod: null,
  energyChannelCommission: null,
  commissionChannelPower: null,
  consumptionEstimated: null,
  addressRoadType: [ { value: null, disabled: false }, [ Validators.required ] ],
  addressName: [ { value: null, disabled: false }, [ Validators.required, Validators.maxLength(100) ] ],
  addressNumber: [ { value: null, disabled: false }, [ Validators.maxLength(8), Validators.pattern(new RegExp(/^[a-zA-Z0-9]+$/)) ] ],
  addressGate: [ { value: null, disabled: false }, Validators.maxLength(10) ],
  addressStair: [ { value: null, disabled: false }, [ Validators.maxLength(3), Validators.pattern(new RegExp(/^[a-zA-Z0-9]+$/)) ] ],
  addressFloor: [ { value: null, disabled: false }, [ Validators.maxLength(3), Validators.pattern(new RegExp(/^[a-zA-Z0-9]+$/)) ] ],
  addressDoor: [ { value: null, disabled: false }, [ Validators.maxLength(3), Validators.pattern(new RegExp(/^[a-zA-Z0-9]+$/)) ] ],
  addressPostalCode: [ { value: null, disabled: false } ],
  addressPostalCodePT1: [ { value: null, disabled: false } ],
  addressPostalCodePT2: [ { value: null, disabled: false } ],
  addressTown: [ { value: null, disabled: true }, [ Validators.required, Validators.maxLength(100) ] ],
  addressProvince: [ { value: null, disabled: true }, [ Validators.required, Validators.maxLength(100) ] ],
  addressNotifRoadType: [ { value: null, disabled: false }, [ Validators.required ] ],
  addressNotifName: [ { value: null, disabled: false }, [ Validators.required, Validators.maxLength(100) ] ],
  addressNotifNumber: [ { value: null, disabled: false }, [ Validators.maxLength(8), Validators.pattern(new RegExp(/^[a-zA-Z0-9]+$/)) ] ],
  addressNotifGate: [ { value: null, disabled: false }, Validators.maxLength(10) ],
  addressNotifStair: [ { value: null, disabled: false }, [ Validators.maxLength(3), Validators.pattern(new RegExp(/^[a-zA-Z0-9]+$/)) ] ],
  addressNotifFloor: [ { value: null, disabled: false }, [ Validators.maxLength(3), Validators.pattern(new RegExp(/^[a-zA-Z0-9]+$/)) ] ],
  addressNotifDoor: [ { value: null, disabled: false }, [ Validators.maxLength(3), Validators.pattern(new RegExp(/^[a-zA-Z0-9]+$/)) ] ],
  addressNotifPostalCode: [ { value: null, disabled: false } ],
  addressNotifPostalCodePT1: [ { value: null, disabled: false } ],
  addressNotifPostalCodePT2: [ { value: null, disabled: false } ],
  addressNotifTown: [ { value: null, disabled: true }, [ Validators.required, Validators.maxLength(100) ] ],
  addressNotifProvince: [ { value: null, disabled: true }, [ Validators.required, Validators.maxLength(100) ] ],
  contactName: [ { value: null, disabled: false }, [ Validators.required, Validators.maxLength(50) ] ],
  contactSurname: [ { value: null, disabled: false }, [ Validators.required, Validators.maxLength(50) ] ],
  contactDocumentNumber: [ { value: null, disabled: false } ],
  contactEmail: [ { value: null, disabled: false } ],
  contactMobileCountryCode: [ { value: null, disabled: false } ],
  contactMobile: [ { value: null, disabled: false } ],
  ibanCode: [ { value: null, disabled: false }, [ Validators.required ] ],
  ibanEntity: [ { value: null, disabled: false }, [ Validators.required ] ],
  ibanOffice: [ { value: null, disabled: false }, [ Validators.required ] ],
  ibanDC: [ { value: null, disabled: false }, [ Validators.required ] ],
  ibanAccount: [ { value: null, disabled: false }, [ Validators.required ] ]
};
@Component({
  selector: 'app-multipoint-installation-pymes',
  templateUrl: './multipoint-installation-pymes.component.html',
  styleUrls: [ './multipoint-installation-pymes.component.scss' ],
  encapsulation: ViewEncapsulation.None
})

export class MultipointInstallationPymesComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<boolean> = new Subject<boolean>();
  public dataDraft: SavedDataMultipoint;
  public installationsForm: FormGroup;
  public roadTypeList: Select[] = [];
  public townAddressList: Select[][] = [];
  public townAddressNotifList: Select[][] = [];
  private codesAddressProvinces: string[] = [];
  private codesAddressNotifProvinces: string[] = [];
  private cupsToValidate: ListCups[] = [];
  private pcsToValidate: ListPostalCode[] = [];
  private apiSubscriptionList: Observable<GenericResponse>[] = [];
  private firstTime = true;
  private isLoadding = false;
  public feeList: Select[] = [
    { value: '2.0TD', label: '2.0TD' },
    { value: '3.0TD', label: '3.0TD' },
    { value: '6.1TD', label: '6.1TD' },
    { value: '6.2TD', label: '6.2TD' },
    { value: '6.3TD', label: '6.3TD' },
    { value: '6.4TD', label: '6.4TD' }
  ];
  private errorsFirstTime = true;
  private errorsServices: ErrorsServices = {
    installations: [],
    tensionCyclePeriod: false,
    errorTensionCyclePeriod: null,
    roadType: false,
    errorRoadType: null
  };
  public isUserSpanish = true;
  public tensionCyclePeriod: Tensions;
  public tensionList: Select[][] = [];
  public tensionNoRepinList: Select[] = [];
  public cycleList: Select[][] = [];
  public periodList: Select[][] = [];
  public potencyList: Select[][] = [];
  private tensionSelected: Tension[] = [];
  private cycleSelected: Cycle[] = [];
  public periodSelected: Period[] = [];
  public minPotency: string[] = [];
  public regexTwoDecimal = new RegExp(/^(\d+(\,\d{0,2})?)$/g);
  public regexThreeDecimal = new RegExp(/^(\d+(\,\d{0,3})?)$/g);
  private patternTwoDecimal = '([0-9]*(,[0-9]{1,2})?)';
  private patternThreeDecimal = '([0-9]*(,[0-9]{1,3})?)';
  public contactMobileCountryCodeList: Select[];
  private isPotencyDisabled = false;
  public repin: boolean[] = [];

  @Input() overWriteInstallations: boolean;
  @Output() data: EventEmitter<InstallationsMultiPoint> = new EventEmitter();
  @Output() changeLoader: EventEmitter<boolean> = new EventEmitter();
  @Output() saveInstallations: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private newContractService: NewContractPymesService,
    private newContractPymesMultipointService: NewContractPymesMultipointService,
    private utilService: UtilService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private utilValidatorsService: UtilValidatorsService,
    private authService: AuthService,
    @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService,
  ) { }

  ngOnInit(): void {
    this.isUserSpanish = this.authService.getUserData().country === 'ES';
    this.newContractPymesMultipointService.resetLoaderInstallations();
    this.getLoader();
    this.getValuesForm();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private getLoader(): void {
    this.newContractPymesMultipointService.getLoaderInstallations().pipe(takeUntil(this.destroyed$)).subscribe(
      value => {
        if (value > 0 && !this.isLoadding) {
          this.isLoadding = true;
          this.changeLoader.emit(true);
        } else if (value === 0) {
          this.isLoadding = false;
          this.changeLoader.emit(false);
        }
      }
    );
  }

  private checkErrors(): void {
    const haveErrorsInstallations = this.errorsServices.installations.some(value =>
      (value.cups && (!!value.errorCups || !!value.errorRepeatCups)) ||
      (value.addressInstallation && !!value.errorAddressInstallation) ||
      (value.addressNotification && !!value.errorAddressNotification)
    );
    const haveErrorsServices = this.errorsServices.roadType && !!this.errorsServices.errorRoadType;
    if (haveErrorsInstallations || haveErrorsServices) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        autoFocus: false,
        disableClose: true,
        width: '575px',
        maxHeight: '575px',
        data: this.errorsServices
      };
      this.dialog.open(MultipointModalErrorEndpointsComponent, dialogConfig.data);
    }
  }

  private getValuesForm(): void {
    this.newContractPymesMultipointService.getSavedDataMultipoint().pipe(takeUntil(this.destroyed$)).subscribe(res => {
      this.dataDraft = res;
      if (this.firstTime) {
        this.createForm();
        this.subscribeFormControl();
        this.firstTime = false;
      } else {
        this.bindErrorsInstallations();
      }
    });
  }

  private createForm(): void {
    this.installationsForm = this.formBuilder.group(
      { installations: this.formBuilder.array([]) }
    );
    this.createErrorsInstallations();
    if (this.dataDraft?.installations?.length > 0) {
      this.dataDraft?.installations.forEach((item: InstallationMultiPoint, index: number) => {
        // item.existeEnRepin ? this.repin.push(true) : this.repin.push(false);
        this.repin.push(false);
        this.addInstallation(index);
        this.preparerCupsAndPCList(item, index);
      });
    } else {
      this.repin.push(false);
      this.addInstallation();
      this.setPCToValidateList(this.installations.controls[ 0 ] as FormGroup, 0);
    }
    this.getRoadTypes();
    if (!this.isUserSpanish) {
      this.getTensionCyclePeriod();
    }
    this.getAllDataInit();
  }

  private preparerCupsAndPCList(item: InstallationMultiPoint, formIndex: number): void {
    const formGroup: FormGroup = this.installations.controls[ formIndex ] as FormGroup;
    this.setCupsToValidateList(formGroup, item?.cups, formIndex);
    this.setPCToValidateList(formGroup, formIndex);
  }

  private getAllDataInit(): void {
    this.newContractPymesMultipointService.setLoaderInstallations(true);
    concat(...this.apiSubscriptionList).pipe(takeUntil(this.destroyed$), last()).subscribe(
      () => {
        this.errorsFirstTime = false;
        this.checkErrors();
        this.newContractPymesMultipointService.setLoaderInstallations(false);
      }
    );
  }

  private setCupsToValidateList(formGroup: FormGroup, cupsValue: string, formIndex: number): void {
    if (!this.isUserSpanish && !formGroup.get('cups').value.includes('PT0002')) {
      this.errorCups(formGroup, this.i18NextService.t('NEW_CONTRACTS.PT_CUPS_VALIDATION_MESSAGE'), true);
    } else {
      if (formGroup.controls.cups.valid) {
        const existCupsIndex = this.cupsToValidate.findIndex(cups => cups.cups === cupsValue);
        if (existCupsIndex === -1) {
          this.cupsToValidate.push({ cups: cupsValue, formIndex: [ formIndex ] });
          this.apiSubscriptionList.push(
            this.newContractPymesMultipointService.validateCups(
              cupsValue,
              this.dataDraft.idDraft
            ).pipe(takeUntil(this.destroyed$))
              .pipe(tap(
                res => this.cupsValidationSetResponse(res, formGroup),
                error => {
                  this.errorCups(formGroup, error);
                  this.newContractPymesMultipointService.setLoaderInstallations(false);
                }
              ))
          );
        } else {
          this.cupsToValidate[ existCupsIndex ].formIndex.push(formIndex);
        }
      }
    }
  }

  private setPCToValidateList(formGroup: FormGroup, formIndex: number): void {
    const pcFieldNames = [ 'addressPostalCode', 'addressNotifPostalCode' ];
    pcFieldNames.forEach((pcFieldName: 'addressPostalCode' | 'addressNotifPostalCode') => {
      if (formGroup.get(pcFieldName).value && this.isValidPostalCode(formGroup, pcFieldName)) {
        const existPCIndex = this.pcsToValidate.findIndex(pcItem => pcItem.pc === formGroup.get(pcFieldName).value);
        if (existPCIndex === -1) {
          this.notExistPostalCodeInitCall(formGroup, pcFieldName, formIndex);
        } else {
          this.existPotalCodeInitCall(existPCIndex, pcFieldName, formIndex);
        }
      }
    });
  }

  private notExistPostalCodeInitCall(
    formGroup: FormGroup,
    pcFieldName: 'addressPostalCode' | 'addressNotifPostalCode',
    formIndex: number
  ): void {
    this.pcsToValidate.push({
      pc: formGroup.get(pcFieldName).value,
      position: [ {
        index: formIndex,
        type: pcFieldName
      } ]
    });
    this.apiSubscriptionList.push(
      this.newContractService.getCodigoPostal(formGroup.get(pcFieldName).value).pipe(takeUntil(this.destroyed$), tap(
        res => this.iteratePostalCodeToValidatePosition(false, res, formGroup.get(pcFieldName).value),
        error => this.iteratePostalCodeToValidatePosition(true, error, formGroup.get(pcFieldName).value)
      ))
    );
  }

  private existPotalCodeInitCall(
    existPCIndex: number,
    pcFieldName: 'addressPostalCode' | 'addressNotifPostalCode',
    formIndex: number
  ): void {
    const pcToValidate = this.pcsToValidate[ existPCIndex ].position;
    const existPCToValidatePositionIndex = pcToValidate.findIndex(pos => pos.index === formIndex);
    if (existPCToValidatePositionIndex === -1) {
      pcToValidate.push({
        index: formIndex,
        type: pcFieldName
      });
    } else {
      pcToValidate[ existPCToValidatePositionIndex ].type = 'all';
    }
  }

  private iteratePostalCodeToValidatePosition(isError: boolean, res: GenericResponse, pcValue: string) {
    const pcValueToValidate = this.pcsToValidate.find(pc => pc.pc === pcValue);
    if (pcValueToValidate) {
      pcValueToValidate.position.forEach(position => {
        const formGroup = this.installations.controls[ position.index ] as FormGroup;
        if (!isError) {
          if (position.type === 'all') {
            this.getPostalCodeResponse(res, 'addressPostalCode', position.index.toString(), formGroup);
            this.getPostalCodeResponse(res, 'addressNotifPostalCode', position.index.toString(), formGroup);
          } else {
            this.getPostalCodeResponse(res, position.type, position.index.toString(), formGroup);
          }
        } else {
          this.errorPostalCode(position.type, position.index.toString(), res);
        }
      });
    }
  }

  private cupsValidationSetResponse(response: GenericResponse<CheckCups>, formGroup: FormGroup): void {
    if (response.success) {
      if (this.isUserSpanish) {
        formGroup.patchValue({
          geographicZone: response.data.zonaGeografica || null,
          cuPsAcepptedCRM: true,
          fee: null,
          feeReal: response.data.tarifaSips,
          codErrorAcepptedCRM: null,
          descriptionErrorAcepptedCRM: null,
          estimatedConsumptionPeriod: response.data.consumoEstimadoPeriodo,
          contractedPowerPeriod: response.data.potenciaContratadaPeriodo,
          energyChannelCommission: response.data.comisionCanalEnergia,
          commissionChannelPower: response.data.comisionCanalPotencia,
          consumptionEstimated: response.data.consumoEstimado?.toString().replace('.', ',')
        });
      } else {
        if (response.data.datosPortugal) {
          this.repin[ formGroup.get('groupIndex').value ] = true;
          this.setCupsTensionRepin(response.data.datosPortugal, formGroup);
          formGroup.get('fee').setValue(response.data.tarifaSips);
          formGroup.get('feeReal').setValue(response.data.tarifaSips);
          formGroup.get('tension').disable();
        } else {
          this.repin[ formGroup.get('groupIndex').value ] = false;
          formGroup.get('tension').enable();
        }
        formGroup.patchValue({
          cuPsAcepptedCRM: true,
          codErrorAcepptedCRM: null,
          descriptionErrorAcepptedCRM: null,
        });
      }
      if (this.hasTDOrTDVEString(response.data.tarifaSips)) {
        formGroup.controls.fee.setValue(response.data.tarifaSips);
        formGroup.controls.fee.disable();
      } else {
        formGroup.controls.fee.enable();
      }
      formGroup.updateValueAndValidity();
      if (this.errorsFirstTime) {
        this.errorsServices.installations[ formGroup.controls.groupIndex.value ].cups = true;
      }
    } else {
      this.errorCups(formGroup, response);
    }
  }

  private errorCups(formGroup: FormGroup, error: any, ptValidation?: boolean): void {
    const messageError = ptValidation ? error : this.getMessageError(error);
    if (this.isUserSpanish) {
      formGroup.patchValue({
        geographicZone: null,
        cuPsAcepptedCRM: false,
        fee: null,
        feeReal: null,
        codErrorAcepptedCRM: error.Info ? error.Info[ 0 ].Code : null,
        descriptionErrorAcepptedCRM: messageError,
        estimatedConsumptionPeriod: null,
        contractedPowerPeriod: null,
        energyChannelCommission: null,
        commissionChannelPower: null,
        consumptionEstimated: null
      });
    }
    else {
      formGroup.patchValue({
        cuPsAcepptedCRM: true,
        codErrorAcepptedCRM: null,
        descriptionErrorAcepptedCRM: null,
      });
    }
    formGroup.controls.cups.setErrors({ invalid: true });
    formGroup.updateValueAndValidity();
    if (this.errorsFirstTime) {
      this.errorsServices.installations[ formGroup.controls.groupIndex.value ].cups = true;
      this.errorsServices.installations[ formGroup.controls.groupIndex.value ].errorCups = messageError;
    } else {
      const name = formGroup.get('name').value ? formGroup.get('name').value : this.i18NextService.t('NEW_CONTRACTS.INSTALLATION_DATA.INSTALLATION') + (formGroup.get('groupIndex').value + 1);
      this.snackBar.open(`${name}: ${messageError}`, 'x', { duration: 10000, panelClass: 'bg-error' });
    }
  }

  private createErrorsInstallations(): void {
    if (this.dataDraft.installations.length > 0) {
      this.dataDraft.installations.forEach(installation => {
        this.errorsServices.installations.push({
          name: installation?.name,
          cups: false,
          errorCups: (!this.isUserSpanish && !installation.cups?.includes('PT0002')) ?
            this.i18NextService.t('NEW_CONTRACTS.PT_CUPS_VALIDATION_MESSAGE') : null,
          errorRepeatCups: null,
          addressInstallation: installation.addressPostalCode ? installation.addressPostalCode?.length <= 4 : true,
          errorAddressInstallation: null,
          addressNotification: installation.addressNotifPostalCode ? installation.addressNotifPostalCode?.length <= 4 : true,
          errorAddressNotification: null,
        });
      });
    } else if (this.dataDraft?.previousInstallation?.chargeManual &&
      this.overWriteInstallations && this.dataDraft?.installations?.length === 0
    ) {
      this.errorsServices.installations.push({
        name: null,
        cups: true,
        errorCups: null,
        errorRepeatCups: null,
        addressInstallation: true,
        errorAddressInstallation: null,
        addressNotification: this.dataDraft.previousInstallation.addressNotifPostalCode ?
          this.dataDraft.previousInstallation.addressNotifPostalCode?.length <= 4 : true,
        errorAddressNotification: null,
      });
    }
  }

  private bindErrorsInstallations(): void {
    this.dataDraft?.installations?.forEach((value, index) => {
      (this.installationsForm.controls.installations as FormArray)?.controls[ index ]?.patchValue({
        sendedCRM: value.sendedCRM,
        registeredCRM: value.registeredCRM,
        codErrorRegisteredCRM: value.codErrorRegisteredCRM,
        descriptionErrorRegisteredCRM: value.descriptionErrorRegisteredCRM,
        codInstallation: value.codInstallation
      });
      this.installationsForm.controls.installations.updateValueAndValidity();
    });
  }

  get installations() {
    return this.installationsForm.controls.installations as FormArray;
  }

  private addInstallation(idx?: number): void {
    const form = this.formBuilder.group(installationForm);
    this.setValidators(form, idx);
    const index = this.installations?.length || 0;
    form.controls.groupIndex.setValue(index);
    form.get('cnae').setValue(this.dataDraft.business?.cnae || '');
    this.subscribeFormControlArray(form, idx);
    if (this.dataDraft?.previousInstallation?.chargeManual && this.overWriteInstallations && !idx && idx !== 0) {
      this.setValuesFormChargeManual(form);
    } else {
      this.setValuesInstallations(form, idx);
      this.checkCups(form, index);
    }
    if (!this.isUserSpanish && form.get('contactMobileCountryCode').value) {
      this.mobileCountryCodeChange(form, form.get('contactMobileCountryCode').value);
    }
    this.installations.push(form);
    this.emitChanges();
    if (this.dataDraft?.previousInstallation?.chargeManual && this.overWriteInstallations &&
      !idx && idx !== 0 && this.dataDraft?.installations?.length === 0 && this.installationsForm?.value?.installations?.length === 1
    ) {
      this.saveInstallations.emit(true);
    }
  }

  private setValidators(form: FormGroup, index: number): void {
    form.get('cups').setValidators(
      [ this.utilValidatorsService.validateCUPS, Validators.required, Validators.maxLength(22) ]
    );
    form.get('cnae').setValidators([ Validators.required, this.utilValidatorsService.validateCNAE ]);
    form.get('contactDocumentNumber').setValidators(
      this.isUserSpanish ? [ this.utilValidatorsService.validateCIFNIF, Validators.required ] : [ this.utilValidatorsService.validateCIFNIF ]
    );
    form.get('contactMobile').setValidators(
      [ this.utilValidatorsService.validateMobile, Validators.required, Validators.maxLength(9) ]
    );
    form.get('contactEmail').setValidators(
      [ Validators.required, Validators.pattern(this.utilValidatorsService.emailPattern), Validators.maxLength(50) ]
    );
    form.setValidators(this.isUserSpanish ? this.validateIBANControls : null);
    this.initPostalCodePT(form, 'addressPostalCode');
    this.initPostalCodePT(form, 'addressNotifPostalCode');
    this.initMobileCountryCodePT(form);
    if (this.isUserSpanish) {
      form.get('fee').setValidators([ Validators.required ]);
    } else {
      form.get('tension').setValidators([ Validators.required ]);
      form.get('cycle').setValidators([ Validators.required ]);
      form.get('period').setValidators([ Validators.required ]);
      form.get('tension').enable();
      form.get('potency').setValidators([ Validators.required ]);
      form.get('consumptionEstimated').setValidators([ Validators.required ]);
      form.get('consumptionEstimated').setValidators(
        [ Validators.required, Validators.pattern(this.patternThreeDecimal) ]
      );
    }
    form.get('ibanCode').setValidators(this.isUserSpanish ? Validators.required: null);
    form.get('ibanEntity').setValidators(this.isUserSpanish ? Validators.required: null);
    form.get('ibanOffice').setValidators(this.isUserSpanish ? Validators.required: null);
    form.get('ibanDC').setValidators(this.isUserSpanish ? Validators.required: null);
    form.get('ibanAccount').setValidators(this.isUserSpanish ? Validators.required: null);
  }

  private checkCups(form: FormGroup, index): void {
    if (form.controls.cups.valid) {
      const errorRepeated = this.checkSameCups(form);
      if (!!errorRepeated) {
        if (this.errorsFirstTime) {
          this.errorsServices.installations[ index ].cups = true;
          this.errorsServices.installations[ index ].errorRepeatCups = errorRepeated;
        }
        form.patchValue({
          geographicZone: null,
          cuPsAcepptedCRM: false,
          fee: null,
          feeReal: null,
          codErrorAcepptedCRM: null,
          descriptionErrorAcepptedCRM: null
        });
      }
    } else if (this.errorsFirstTime) {
      this.errorsServices.installations[ index ].cups = true;
    }
  }

  private setValuesFormChargeManual(form: FormGroup): void {
    const data = this.dataDraft.previousInstallation;
    if (data?.allAddressNotification) {
      form.patchValue({
        addressNotifRoadType: data?.addressNotifRoadType || null,
        addressNotifName: data?.addressNotifName || null,
        addressNotifNumber: data?.addressNotifNumber || null,
        addressNotifGate: data?.addressNotifGate || null,
        addressNotifStair: data?.addressNotifStair || null,
        addressNotifFloor: data?.addressNotifFloor || null,
        addressNotifDoor: data?.addressNotifDoor || null,
        addressNotifPostalCode: data?.addressNotifPostalCode || null,
        addressNotifPostalCodePT1: this.isUserSpanish
          ? null : data?.addressNotifPostalCode?.slice(0, 4) || '',
        addressNotifPostalCodePT2: this.isUserSpanish
          ? null : data?.addressNotifPostalCode?.slice(5, 8) || '',
        addressNotifTown: data?.addressNotifTown || null,
        addressNotifProvince: data?.addressNotifProvince || null
      });
    }
    if (data?.allContactPerson) {
      const mobileAndCountryCode = this.getMobileAndCountryCode(data?.contactMobile);
      form.patchValue({
        contactName: data?.contactName || null,
        contactSurname: data?.contactSurname || null,
        contactDocumentNumber: data?.contactDocumentNumber,
        contactEmail: data?.contactEmail || null,
        contactMobileCountryCode: this.isUserSpanish ? null : mobileAndCountryCode.countryCode || null,
        contactMobile: mobileAndCountryCode.mobile
      });
    }
    if (data?.allAccountBank) {
      form.patchValue({
        ibanCode: data?.ibanCode || null,
        ibanEntity: data?.ibanEntity || null,
        ibanOffice: data?.ibanOffice || null,
        ibanDC: data?.ibanDC || null,
        ibanAccount: data?.ibanAccount || null
      });
    }
  }

  private setValuesInstallations(form: FormGroup, index: number): void {
    const data = this.dataDraft.installations[ index ];
    const mobileAndCountryCode = this.getMobileAndCountryCode(data?.contactMobile);
    const installationValues = {
      name: data?.name || null,
      cups: data?.cups || '',
      cnae: data?.cnae || this.dataDraft.business?.cnae || '',
      fee: data?.fee || null,
      feeReal: data?.feeReal || null,
      geographicZone: data?.geographicZone || null,
      cuPsAcepptedCRM: data?.cuPsAcepptedCRM || false,
      codErrorAcepptedCRM: data?.codErrorAcepptedCRM || null,
      descriptionErrorAcepptedCRM: data?.descriptionErrorAcepptedCRM || null,
      codInstallation: data?.codInstallation || null,
      sendedCRM: data?.sendedCRM || false,
      registeredCRM: data?.registeredCRM || false,
      codErrorRegisteredCRM: data?.codErrorRegisteredCRM || null,
      descriptionErrorRegisteredCRM: data?.descriptionErrorRegisteredCRM || null,
      estimatedConsumptionPeriod: data?.estimatedConsumptionPeriod || null,
      contractedPowerPeriod: data?.contractedPowerPeriod || null,
      energyChannelCommission: data?.energyChannelCommission || null,
      commissionChannelPower: data?.commissionChannelPower || null,
      consumptionEstimated: data?.consumptionEstimated?.toString().replace('.', ',') || null,
      tension: data?.tension || null,
      cycle: data?.cycle || null,
      period: data?.period || null,
      cycleName: data?.cycleName || null,
      periodName: data?.periodName || null,
      addressRoadType: data?.addressRoadType || null,
      addressName: data?.addressName || null,
      addressNumber: data?.addressNumber || null,
      addressGate: data?.addressGate || null,
      addressStair: data?.addressStair || null,
      addressFloor: data?.addressFloor || null,
      addressDoor: data?.addressDoor || null,
      addressPostalCode: data?.addressPostalCode || null,
      addressPostalCodePT1: this.isUserSpanish
        ? null : data?.addressPostalCode?.slice(0, 4) || '',
      addressPostalCodePT2: this.isUserSpanish
        ? null : data?.addressPostalCode?.slice(5, 8) || '',
      addressTown: data?.addressTown || null,
      addressProvince: data?.addressProvince || null,
      addressNotifRoadType: data?.addressNotifRoadType || null,
      addressNotifName: data?.addressNotifName || null,
      addressNotifNumber: data?.addressNotifNumber || null,
      addressNotifGate: data?.addressNotifGate || null,
      addressNotifStair: data?.addressNotifStair || null,
      addressNotifFloor: data?.addressNotifFloor || null,
      addressNotifDoor: data?.addressNotifDoor || null,
      addressNotifPostalCode: data?.addressNotifPostalCode || null,
      addressNotifPostalCodePT1: this.isUserSpanish
        ? null : data?.addressNotifPostalCode?.slice(0, 4) || null,
      addressNotifPostalCodePT2: this.isUserSpanish
        ? null : data?.addressNotifPostalCode?.slice(5, 8) || null,
      addressNotifTown: data?.addressNotifTown || null,
      addressNotifProvince: data?.addressNotifProvince || null,
      contactName: data?.contactName || null,
      contactSurname: data?.contactSurname || null,
      contactDocumentNumber: data?.contactDocumentNumber || '',
      contactEmail: data?.contactEmail || null,
      contactMobileCountryCode: this.isUserSpanish ? null : mobileAndCountryCode.countryCode || null,
      contactMobile: mobileAndCountryCode.mobile,
      ibanCode: data?.ibanCode || null,
      ibanEntity: data?.ibanEntity || null,
      ibanOffice: data?.ibanOffice || null,
      ibanDC: data?.ibanDC || null,
      ibanAccount: data?.ibanAccount || null
    };
    form.patchValue(installationValues, { emitEvent: false });
  }

  private enableFields(): void {
    if (!this.isUserSpanish) {
      (this.installationsForm.controls.installations as FormArray).controls.forEach(
        (formGroup: FormGroup, index: number) => {
          if (!this.repin[ index ]) {
            this.tensionSelected[ index ] =
              this.tensionCyclePeriod.tensiones.find(tension => tension.codigoCRM === formGroup.get('tension').value);
            if (this.tensionSelected) {
              this.cycleList[ index ] = this.tensionSelected[ index ]?.ciclos?.map(cycle => ({ label: cycle.descripcion, value: cycle.codigoCRM }));
              this.cycleSelected[ index ] = this.tensionSelected[ index ]?.ciclos?.find(cycle2 => cycle2.codigoCRM === formGroup.get('cycle').value);
              this.periodList[ index ] =
                this.cycleSelected[ index ]?.periodos?.map(period2 => ({ label: period2.descripcion, value: period2.codigoCRM }));
              this.periodSelected[ index ] =
                this.cycleSelected[ index ]?.periodos?.find(period => period.codigoCRM === formGroup.get('period').value);
              if (this.periodSelected[ index ]?.potencias?.length > 0) {
                this.setPotencyOrdened(index);
              }
            } else {
              this.cycleList.push([]);
              this.periodList.push([]);
              this.potencyList.push([]);
              this.minPotency.push(null);
            }
            this.enableFieldIfValue(formGroup, 'tension', 'cycle');
            this.enableFieldIfValue(formGroup, 'cycle', 'period');
            this.enableFieldIfValue(formGroup, 'period', 'potency');
          }
          this.setPotencyValue(formGroup, index);
        }
      );
    }
  }

  private enableFieldIfValue(formGroup: FormGroup, key1: string, key2: string): void {
    if (formGroup.get(key1).value) {
      formGroup.get(key2).enable();
    }
  }

  public deleteInstallation(index: number): void {
    this.installations.removeAt(index);
    this.installations.controls.forEach(control => {
      if (control.get('groupIndex').value > index) {
        control.get('groupIndex').setValue(control.get('groupIndex').value - 1);
      }
    });
    this.townAddressList.splice(index, 1);
    this.townAddressNotifList.splice(index, 1);
    this.tensionSelected.splice(index, 1);
    this.cycleSelected.splice(index, 1);
    this.cycleList.splice(index, 1);
    this.periodSelected.splice(index, 1);
    this.periodList.splice(index, 1);
    this.repin.splice(index, 1);
  }

  private subscribeFormControl(): void {
    this.installationsForm.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.emitChanges();
    });
  }

  private subscribeFormControlArray(formGroup: FormGroup, index: number): void {
    this.subscribeCups(formGroup);
    this.subscribeAddress(formGroup, 'addressPostalCode');
    this.subscribeAddress(formGroup, 'addressNotifPostalCode');
    if (!this.isUserSpanish) {
      this.subscribeCustomPotency(formGroup, index);
      this.subscribeAddressPortugal(formGroup, 'addressPostalCode');
      this.subscribeAddressPortugal(formGroup, 'addressNotifPostalCode');
      this.subscribeMobilePortugal(formGroup);
    }
  }

  private subscribeCups(formGroup: FormGroup): void {
    formGroup.get('cups').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      if (formGroup.get('cups').valid && !this.checkSameCups(formGroup)) {
        if (!this.isUserSpanish && !formGroup.get('cups').value.includes('PT0002')) {
          this.resetTensionCyclePeriodPotency(formGroup);
          this.errorCups(formGroup, this.i18NextService.t('NEW_CONTRACTS.PT_CUPS_VALIDATION_MESSAGE'), true);
        } else {
          this.cupValidation(formGroup);
        }
      } else {
        if (this.isUserSpanish) {
          formGroup.patchValue({
            geographicZone: null,
            cuPsAcepptedCRM: false,
            fee: null,
            feeReal: null,
            codErrorAcepptedCRM: null,
            descriptionErrorAcepptedCRM: null,
            estimatedConsumptionPeriod: null,
            contractedPowerPeriod: null,
            consumptionEstimated: null,
            energyChannelCommission: null,
            commissionChannelPower: null,
          });
        } else {
          const cupsValues = {
            cuPsAcepptedCRM: true,
            codErrorAcepptedCRM: null,
            descriptionErrorAcepptedCRM: null,
          };
          if (this.repin[ formGroup.get('groupIndex').value ]) {
            cupsValues[ 'tension' ] = null;
            cupsValues[ 'cycle' ] = null;
            cupsValues[ 'period' ] = null;
          }
          formGroup.patchValue(cupsValues);
        }
      }
    });
  }

  private subscribeAddress(formGroup: FormGroup, key: string): void {
    const town = key === 'addressPostalCode' ? 'addressTown' : 'addressNotifTown';
    const province = key === 'addressPostalCode' ? 'addressProvince' : 'addressNotifProvince';
    formGroup.get(key).valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      formGroup.get(town).setValue(null);
      formGroup.get(province).setValue(null);
      if (value && this.isValidPostalCode(formGroup, key)) {
        this.getPostalCode(formGroup, value, key);
      } else {
        const index = formGroup.get('groupIndex').value;
        this.townAddressList[ index ] = key === 'addressPostalCode' ? [] : this.townAddressList[ index ];
        this.townAddressNotifList[ index ] = key === 'addressNotifPostalCode' ? [] : this.townAddressNotifList[ index ];
        formGroup.get(town).disable();
      }
    });
  }

  public onChangeTension(formGroup: FormGroup, value: string, formGroupIndex: number): void {
    const tensionsWithOtherPotency = [ 'AT', 'MT', 'HT' ];
    this.tensionSelected[ formGroupIndex ] = this.tensionCyclePeriod.tensiones.find(tension => tension.codigoCRM === value);
    this.cycleList[ formGroupIndex ] = this.tensionSelected[ formGroupIndex ].ciclos.map(
      cycle => ({ label: cycle.descripcion, value: cycle.codigoCRM })
    );
    formGroup.get('tension').setValue(value);
    formGroup.get('cycle').enable();
    formGroup.get('cycle').setValue(null);
    formGroup.get('period').setValue(null);
    formGroup.get('period').disable();
    if (tensionsWithOtherPotency.indexOf(value) >= 0) {
      this.isPotencyDisabled = true;
      formGroup.get('potency').setValue('Otro');
      formGroup.get('customPotency').disable();
      formGroup.get('customPotency').setValidators(
        [ Validators.required, Validators.pattern(this.patternTwoDecimal) ]
      );
    } else {
      this.isPotencyDisabled = false;
      formGroup.get('potency').setValue(null);
      formGroup.get('customPotency').disable();
      formGroup.get('customPotency').clearValidators();
    }
    formGroup.get('potency').disable();
    formGroup.get('customPotency').setValue(null);
    formGroup.get('customPotency').updateValueAndValidity();
    formGroup.get('consumptionEstimated').setValue(null);
    formGroup.get('consumptionEstimated').disable();
  }

  public onChangeCycle(formGroup: FormGroup, value: string, formGroupIndex: number): void {
    if (this.repin[ formGroup.get('groupIndex').value ]) {
      this.cycleSelected[ formGroupIndex ] = this.tensionSelected[ formGroupIndex ].ciclos?.find(cycle => cycle.codigoCRM === value);
      formGroup.get('cycle').setValue(value);
      this.enableTensionCyclePeriodPotencyConsumtionRepin(formGroup);
    } else {
      this.cycleSelected[ formGroupIndex ] = this.tensionSelected[ formGroupIndex ].ciclos.find(cycle => cycle.codigoCRM === value);
      this.periodList[ formGroupIndex ] = this.cycleSelected[ formGroupIndex ].periodos.map(
        period => ({ label: period.descripcion, value: period.codigoCRM })
      );
      formGroup.get('cycle').setValue(value);
      formGroup.get('period').setValue(null);
      formGroup.get('period').enable();
      if (!this.isPotencyDisabled) {
        formGroup.get('potency').setValue(null);
      }
      formGroup.get('potency').disable();
      formGroup.get('customPotency').setValue(null);
    }
  }

  public onChangePeriod(formGroup: FormGroup, value: string, index: number): void {
    this.periodSelected[ index ] = this.cycleSelected[ index ].periodos.find(period => period.codigoCRM === value);
    this.setPotencyOrdened(index);
    formGroup.get('period').setValue(value);
    if (!this.isPotencyDisabled) {
      formGroup.get('potency').setValue(null);
      formGroup.get('potency').enable();
      formGroup.get('customPotency').disable();
      formGroup.get('customPotency').clearValidators();
      formGroup.get('consumptionEstimated').disable();
    } else {
      formGroup.get('potency').setValue('Otro');
      formGroup.get('customPotency').enable();
      formGroup.get('consumptionEstimated').enable();
      formGroup.get('customPotency').setValidators(
        [ Validators.required, Validators.pattern(this.patternTwoDecimal) ]
      );
    }
    formGroup.get('customPotency').setValue(null);
  }

  public onChangePotency(formGroup: FormGroup, value: string): void {
    const contractedPowerPeriodValue = value === 'Otro' ? [ 0, 0, 0, 0, 0, 0 ] : [ parseFloat(value.replace(',', '.')), 0, 0, 0, 0, 0 ];
    formGroup.get('contractedPowerPeriod').setValue(contractedPowerPeriodValue);
    formGroup.get('potency').setValue(value);
    formGroup.get('customPotency').setValue(null);
    formGroup.get('consumptionEstimated').enable();
    if (value === 'Otro') {
      formGroup.get('customPotency').enable();
      formGroup.get('customPotency').setValidators(
        [ Validators.required, Validators.pattern(this.patternTwoDecimal) ]
      );
    } else {
      formGroup.get('customPotency').disable();
      formGroup.get('customPotency').clearValidators();
    }
    formGroup.get('customPotency').updateValueAndValidity();
  }

  private subscribeCustomPotency(formGroup: FormGroup, index: number): void {
    formGroup.get('customPotency').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      if (value && typeof (value) === 'string') {
        formGroup.get('contractedPowerPeriod').setValue([ parseFloat(value.replace(',', '.')), 0, 0, 0, 0, 0 ]);
        const minNumber = parseFloat(this.minPotency[ formGroup.get('groupIndex').value ]?.replace(',', '.'));
        const numberPotency = parseFloat(value?.replace(',', '.'));
        if (numberPotency <= minNumber) {
          formGroup.get('customPotency').setErrors(
            { ...formGroup.get('customPotency').errors, min: true }
          );
        } else {
          const errorCustom = formGroup.get('customPotency').errors;
          delete errorCustom?.min;
          formGroup.get('customPotency').setErrors(
            errorCustom
          );
        }
      }
    });
  }

  private setPotencyOrdened(index: number): void {
    const aux = [ ...this.periodSelected[ index ]?.potencias ];
    const indexOther = aux.findIndex(val => (val.valor === 'Otro'));
    if (indexOther !== - 1) {
      aux.splice(indexOther, 1);
    }
    aux.sort((previous, current) => {
      return parseFloat(previous.valor.replace(',', '.')) - parseFloat(current.valor.replace(',', '.'));
    });
    const installationPotencyList = aux.map(value => ({ label: value.valor, value: value.valor }));
    this.potencyList[ index ] = installationPotencyList;
    this.minPotency[ index ] = installationPotencyList[ installationPotencyList.length - 1 ].value;
    if (indexOther !== - 1) {
      this.potencyList[ index ].push(
        { label: this.i18NextService.t('NEW_CONTRACTS.OTHER_POTENCY'), value: 'Otro' }
      );
    }
  }

  private getPostalCode(formGroup: FormGroup, value: string, block: string): void {
    this.newContractPymesMultipointService.setLoaderInstallations(true);
    const index = formGroup.get('groupIndex').value;
    this.newContractService.getCodigoPostal(value).pipe(takeUntil(this.destroyed$)).subscribe(
      res => {
        this.getPostalCodeResponse(res, block, index, formGroup);
        this.newContractPymesMultipointService.setLoaderInstallations(false);
      },
      error => {
        this.errorPostalCode(block, index, error);
        this.newContractPymesMultipointService.setLoaderInstallations(false);
      }
    );
  }

  private getPostalCodeResponse(res: GenericResponse, block: string, index: string, formGroup: FormGroup) {
    const townInput = block === 'addressPostalCode' ? 'addressTown' : 'addressNotifTown';
    const provinceInput = block === 'addressPostalCode' ? 'addressProvince' : 'addressNotifProvince';
    if (res.success) {
      if (this.errorsFirstTime) {
        if (block === 'addressPostalCode') {
          this.errorsServices.installations[ index ].addressInstallation = true;
        } else {
          this.errorsServices.installations[ index ].addressNotification = true;
        }
      }

      const addresList = res.data.poblaciones ? [ ...this.mapSelect(res.data.poblaciones, 'nombrePoblacion', 'codigoPoblacion') ] : [];
      this.townAddressList[ index ] = block === 'addressPostalCode' ? addresList : this.townAddressList[ index ];
      this.townAddressNotifList[ index ] = block === 'addressNotifPostalCode' ? addresList : this.townAddressNotifList[ index ];
      if (addresList.length <= 1) {
        formGroup.get(townInput).setValue(addresList[ 0 ]?.label);
        formGroup.get(townInput).disable();
      } else {
        formGroup.get(townInput).enable();
      }
      if (res.data?.nombreProvincia) {
        formGroup.get(provinceInput).setValue(res.data?.nombreProvincia);
        this.codesAddressProvinces[ index ] = block === 'addressPostalCode' ? res.data.codigoProvincia : this.codesAddressProvinces[ index ];
        this.codesAddressNotifProvinces[ index ] = block === 'addressNotifPostalCode' ?
          res.data.codigoProvincia : this.codesAddressNotifProvinces[ index ];
      }
      formGroup.updateValueAndValidity();
    } else {
      this.errorPostalCode(block, index, res);
    }
  }

  private errorPostalCode(block: string, index: string, response: GenericResponse | HttpErrorResponse): void {
    if (block === 'addressPostalCode') {
      this.townAddressList[ index ] = [];
    } else {
      this.townAddressNotifList[ index ] = [];
    }
    if (this.errorsFirstTime) {
      if (block === 'addressPostalCode') {
        this.errorsServices.installations[ index ].addressInstallation = true;
        this.errorsServices.installations[ index ].errorAddressInstallation = this.getMessageError(response);
      } else {
        this.errorsServices.installations[ index ].addressNotification = true;
        this.errorsServices.installations[ index ].errorAddressNotification = this.getMessageError(response);
      }
    } else {
      this.utilService.toastErrors(response);
    }
  }

  private cupValidation(formGroup: FormGroup): void {
    this.newContractPymesMultipointService.setLoaderInstallations(true);
    this.newContractPymesMultipointService.validateCups(
      formGroup.controls.cups.value,
      this.dataDraft.idDraft
    ).pipe(takeUntil(this.destroyed$)).subscribe(
      response => {
        if (!this.isUserSpanish) {
          this.resetTensionCyclePeriodPotency(formGroup);
        }
        this.cupsValidationSetResponse(response, formGroup);
        this.newContractPymesMultipointService.setLoaderInstallations(false);
      },
      error => {
        this.errorCups(formGroup, error);
        this.newContractPymesMultipointService.setLoaderInstallations(false);
      }
    );
  }

  private getRoadTypes(): void {
    this.apiSubscriptionList.push(
      this.newContractService.getTipoVia().pipe(takeUntil(this.destroyed$)).pipe(tap(
        res => {
          if (res.success) {
            this.errorsServices.roadType = true;
            this.roadTypeList = [ ...this.mapSelect(res.data, 'nombreTipoVia', 'nombreTipoVia') ];
          } else {
            this.errorMessageRoadTypes(res);
          }
        },
        error => {
          this.errorMessageRoadTypes(error);
        }
      ))
    );
  }

  private errorMessageRoadTypes(error: any): void {
    this.roadTypeList = [];
    this.errorsServices.roadType = true;
    this.errorsServices.errorRoadType = this.getMessageError(error);
  }

  private getTensionCyclePeriod(): void {
    this.apiSubscriptionList.push(this.newContractService.getTensionCyclePeriod().pipe(takeUntil(this.destroyed$), tap(
      response => {
        if (response.success) {
          this.errorsServices.tensionCyclePeriod = true;
          this.tensionCyclePeriod = response.data;
          this.tensionNoRepinList = this.tensionCyclePeriod.tensiones.map(tension => ({ label: tension.descripcion, value: tension.codigoCRM }));
          this.enableFields();
        } else {
          this.errorMessageTensionCyclePeriod(response);
        }
      },
      error => {
        this.errorMessageTensionCyclePeriod(error);
      }
    )));
  }

  private errorMessageTensionCyclePeriod(error: any): void {
    this.errorsServices.tensionCyclePeriod = true;
    this.errorsServices.errorTensionCyclePeriod = this.getMessageError(error);
  }

  private getMessageError(error: any): string {
    let message: string;
    if (error.status === 500 || error.status === 0) {
      message = this.i18NextService.t('COMMONS.CONNECTION_ERROR');
    } else if (error.status === 504) {
      message = this.i18NextService.t('COMMONS.TIME_OUT');
    } else {
      message = error.Info ? error.Info[ 0 ].Message : error.message ? error.message : this.i18NextService.t('COMMONS.ERROR');
    }
    return message;
  }

  private validateIBANControls(control: AbstractControl): ValidationErrors | null {
    const iban = control.get('ibanCode').value;
    const entity = control.get('ibanEntity').value;
    const office = control.get('ibanOffice').value;
    const dc = control.get('ibanDC').value;
    const account = control.get('ibanAccount').value;

    if (!validateIBAN(iban + entity + office + dc + account)) {
      return { invalid_IBAN: true };
    }
    return null;
  }

  private mapSelect(values, label, value): Select[] {
    return values.map(element => {
      return { label: element[ label ], value: element[ value ] };
    });
  }

  public handleAddInstallation(): void {
    this.addInstallation();
  }

  private emitChanges(): void {
    const data: InstallationsMultiPoint = {
      canGoNext: this.checkCanGoNext(),
      ...this.installationsForm.getRawValue()
    };
    data.installations.forEach((item: InstallationMultiPoint) => {
      const index = item.groupIndex;
      if (this.townAddressList[ index ]?.length === 1) {
        item.addressTown = this.townAddressList[ index ][ 0 ]?.value;
      }
      if (this.townAddressNotifList[ index ]?.length === 1) {
        item.addressNotifTown = this.townAddressNotifList[ index ][ 0 ].value;
      }
      item.addressProvince = this.codesAddressProvinces[ index ];
      item.addressNotifProvince = this.codesAddressNotifProvinces[ index ];
      if (!this.isUserSpanish) {
        if (item.contactMobileCountryCode) {
          item.contactMobile = item.contactMobileCountryCode + item.contactMobile;
        }
        item.consumptionEstimated = item.consumptionEstimated ? parseFloat(item.consumptionEstimated?.toString().replace(',', '.')) : null;
        if (this.tensionCyclePeriod) {
          const tension = this.tensionCyclePeriod?.tensiones?.find(tensionItem => tensionItem?.codigoCRM === item?.tension);
          const cycle = tension?.ciclos?.find(cycleItem => cycleItem?.codigoCRM === item?.cycle);
          const period = cycle?.periodos?.find(periodItem => periodItem?.codigoCRM === item?.period);
          item.feeName = tension?.codigoCRM + ' - ' + cycle?.descripcion?.split(' - ')[0] + ' - ' + period?.descripcion;
        }
      }
    });
    this.data.emit(data);
  }

  private checkCanGoNext(): boolean {
    return this.installations.controls.every((form: FormGroup) => (
      form.status === 'VALID' &&
      !!form.controls.addressTown.value && !!form.controls.addressProvince.value &&
      !!form.controls.addressNotifTown.value && !!form.controls.addressNotifProvince.value &&
      this.installations.controls.every((form2: FormGroup) => {
        if (form2.controls.groupIndex.value !== form.controls.groupIndex.value) {
          if (form2.controls.cups.value !== form.controls.cups.value) {
            return true;
          }
        } else {
          return true;
        }
      })
    ));
  }

  private checkSameCups(form: FormGroup): string {
    for (const form2 of this.installations.controls) {
      if ((form2 as FormGroup).controls.groupIndex.value !== form.controls.groupIndex.value) {
        if ((form2 as FormGroup).controls.cups.value === form.controls.cups.value) {
          const name = (form2 as FormGroup).controls.name.value ? (form2 as FormGroup).controls.name.value :
            `${this.i18NextService.t('NEW_CONTRACTS.INSTALLATION_DATA.INSTALLATION')} ${parseInt((form2 as FormGroup).controls.groupIndex.value, 10) + 1}`;
          const message = `${this.i18NextService.t('NEW_CONTRACTS.INSTALLATION_DATA.ERROR_SAME_CUPS')}: ${name}`;
          if (!this.errorsFirstTime) {
            this.snackBar.open(message, 'x', { duration: 10000, panelClass: 'bg-error' });
          }
          return message;
        }
      }
    }
    return null;
  }

  public hasTDOrTDVEString(feeRealValue: string): boolean {
    return !!feeRealValue ? feeRealValue.slice(-2).toUpperCase() === 'TD' || feeRealValue.slice(-4).toUpperCase() === 'TDVE' : false;
  }

  public customErrorMatcher(keyError: string): MyErrorStateMatcher {
    return new MyErrorStateMatcher(true, keyError);
  }

  public checkControlRequired(control: FormControl): boolean {
    return control.errors?.required;
  }

  public checkControlCups(control: FormControl): boolean {
    if (!this.dataDraft?.previousInstallation?.chargeManual) {
      return !!control.value && !!control.errors?.invalid_cups;
    } else {
      return !!control.value && !!control.errors?.invalid_cups && (control.touched || control.dirty);
    }
  }

  public checkControlDni(control: FormControl): boolean {
    if (!this.dataDraft?.previousInstallation?.chargeManual) {
      return !!control.value && (control.errors?.invalid_dni || !!control.errors?.invalid_cif);
    } else {
      return !!control.value &&
        (control.errors?.invalid_dni || !!control.errors?.invalid_cif) && (control.touched || control.dirty);
    }
  }

  public checkControlEmail(control: FormControl): boolean {
    if (!this.dataDraft?.previousInstallation?.chargeManual) {
      return !!control.value && !!control.errors?.pattern;
    } else {
      return !!control.value && !!control.errors?.pattern && (control.touched || control.dirty);
    }
  }

  public checkControlMobile(control: FormControl): boolean {
    if (!this.dataDraft?.previousInstallation?.chargeManual) {
      return !!control.value && control.errors?.invalid_mobile;
    } else {
      return !!control.value && control.errors?.invalid_mobile && (control.touched || control.dirty);
    }
  }

  public checkControlIban(formGroup: FormGroup): boolean {
    const keysObject = Object.keys(formGroup.controls).filter(val => val.startsWith('iban'));
    const haveValues = keysObject.some(key => !!formGroup.get(key).value);
    const touchedOrDirty = keysObject.some(key => formGroup.get(key).touched || formGroup.get(key).dirty);
    if (!this.dataDraft?.previousInstallation?.chargeManual) {
      return haveValues && formGroup.hasError('invalid_IBAN');
    } else {
      return haveValues && formGroup.hasError('invalid_IBAN') && touchedOrDirty;
    }
  }

  public installationAddressHaveError(form: FormGroup, checkNotifAddress: boolean): boolean {
    return form.get(checkNotifAddress ? 'addressNotifRoadType' : 'addressRoadType').invalid ||
      form.get(checkNotifAddress ? 'addressNotifName' : 'addressName').invalid ||
      form.get(checkNotifAddress ? 'addressNotifNumber' : 'addressNumber').invalid ||
      form.get(checkNotifAddress ? 'addressNotifGate' : 'addressGate').invalid ||
      form.get(checkNotifAddress ? 'addressNotifStair' : 'addressStair').invalid ||
      form.get(checkNotifAddress ? 'addressNotifFloor' : 'addressFloor').invalid ||
      form.get(checkNotifAddress ? 'addressNotifDoor' : 'addressDoor').invalid ||
      form.get(checkNotifAddress ? 'addressNotifPostalCode' : 'addressPostalCode').invalid ||
      form.get(checkNotifAddress ? 'addressNotifTown' : 'addressTown').invalid ||
      form.get(checkNotifAddress ? 'addressNotifProvince' : 'addressProvince').invalid;
  }

  public installationContactHaveError(form: FormGroup): boolean {
    return form.get('contactName').invalid ||
      form.get('contactSurname').invalid ||
      form.get('contactDocumentNumber').invalid ||
      form.get('contactEmail').invalid ||
      form.get('contactMobile').invalid;
  }

  public installationIbanHaveError(form: FormGroup): boolean {
    return form.hasError('invalid_IBAN')
      || form.get('ibanCode').invalid
      || form.get('ibanEntity').invalid
      || form.get('ibanOffice').invalid
      || form.get('ibanDC').invalid
      || form.get('ibanAccount').invalid;
  }

  public onPasteIBAN(event: ClipboardEvent, installationFormIndex: number): void {
    const pasteIBAN: string = event.clipboardData.getData('text').replace(/\s/g, '');
    if (pasteIBAN && pasteIBAN.length === 24) {
      this.installations.controls[ installationFormIndex ]?.patchValue({
        ibanCode: pasteIBAN.slice(0, 4),
        ibanEntity: pasteIBAN.slice(4, 8),
        ibanOffice: pasteIBAN.slice(8, 12),
        ibanDC: pasteIBAN.slice(12, 14),
        ibanAccount: pasteIBAN.slice(14, 24)
      });
    }
  }

  public bankAccountKeyUp(
    event: KeyboardEvent,
    previousInputId: string | null,
    currentInputId: string,
    nextInputId: string | null,
    index: number
  ): void {
    const previousInput = this.getInputElement(previousInputId, index);
    const currentInput = this.getInputElement(currentInputId, index);
    const nextInput = this.getInputElement(nextInputId, index);
    if (!event.ctrlKey && event.key !== 'Control') {
      if (currentInput.selectionStart === currentInput.maxLength && nextInput) {
        nextInput.focus();
        nextInput.setSelectionRange(0, 0);
      } else if (
        (event.key === 'Backspace' || event.key === 'ArrowLeft')
        && currentInput.selectionStart === 0
        && previousInput
      ) {
        previousInput.focus();
      }
    }
  }

  private getInputElement(id: string, index: number): HTMLInputElement | null {
    return id ? (document.getElementById(id + index) as HTMLInputElement) : null;
  }

  private initPostalCodePT(installationFormGroup: FormGroup, key: string): void {
    if (this.isUserSpanish) {
      installationFormGroup.get(key).setValidators([ Validators.required, Validators.minLength(5) ]);
    } else {
      installationFormGroup.get(key + 'PT1').setValidators([ Validators.required, Validators.maxLength(4) ]);
      installationFormGroup.get(key + 'PT2').setValidators([ Validators.required, Validators.maxLength(3) ]);
      installationFormGroup.get(key).setValidators([
        Validators.required,
        Validators.pattern(this.utilValidatorsService.postalCodePTPattern)
      ]);
    }
  }

  private subscribeAddressPortugal(installationFormGroup: FormGroup, key: string): void {
    installationFormGroup.get(key + 'PT1').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      installationFormGroup.get(key).setValue(
        value + '-' + installationFormGroup.get(key + 'PT2').value
      );
    });
    installationFormGroup.get(key + 'PT2').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(value => {
      installationFormGroup.get(key).setValue(
        installationFormGroup.get(key + 'PT1').value + '-' + value
      );
    });
  }

  private isValidPostalCode(installationFormGroup: FormGroup, key: string): boolean {
    if (this.isUserSpanish) {
      return installationFormGroup.get(key).value?.length > 4;
    } else {
      return installationFormGroup.get(key + 'PT1').value?.length === 4 &&
        installationFormGroup.get(key + 'PT2').value?.length === 3 &&
        installationFormGroup.get(key).value?.length === 8;
    }
  }

  private subscribeMobilePortugal(installationFormGroup: FormGroup): void {
    installationFormGroup.get('contactMobileCountryCode').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(
      value => {
        if (value) {
          this.mobileCountryCodeChange(installationFormGroup, value);
        }
      }
    );
  }

  private mobileCountryCodeChange(installationFormGroup: FormGroup, value: string): void {
    installationFormGroup.get('contactMobile').enable();
    if (value === '0034') {
      installationFormGroup.get('contactMobile').setValidators(
        [ this.utilValidatorsService.validateMobile, Validators.maxLength(9) ]
      );
    } else if (value === '00351') {
      installationFormGroup.get('contactMobile').setValidators(
        [ this.utilValidatorsService.validateMobilePT, Validators.maxLength(9) ]
      );
    }
    installationFormGroup.get('contactMobile').updateValueAndValidity({ onlySelf: true });
  }

  private getMobileAndCountryCode(value: string | null): Mobile {
    const result: Mobile = { mobile: value };
    if (value) {
      if (!this.isUserSpanish && value?.length > 9) {
        const countryCode = value.slice(0, value.length - 9);
        const validCountryCode = this.contactMobileCountryCodeList.find(code => code.value === countryCode);
        if (validCountryCode) {
          result.countryCode = countryCode;
        }
      }
      result.mobile = value.slice(value.length - 9, value.length);
    }

    return result;
  }

  private initMobileCountryCodePT(installationFormGroup: FormGroup): void {
    if (!this.isUserSpanish) {
      installationFormGroup.get('contactMobileCountryCode').setValidators(Validators.required);
      this.i18NextService.events.languageChanged.pipe(takeUntil(this.destroyed$)).subscribe(() => {
        this.contactMobileCountryCodeList = this.utilService.getListCountryMobile();
      });
    }
  }

  private setPotencyValue(formGroup: FormGroup, index: number): void {
    const value = formGroup.get('contractedPowerPeriod').value;
    const minNumber = parseFloat(this.minPotency[ index ]?.replace(',', '.'));
    if (value?.length > 0) {
      if ((value[ 0 ] <= minNumber && parseFloat(value[ 0 ]?.toString().replace('.', ',')) > 0) || !this.minPotency[ index ]) {
        formGroup.get('potency').setValue(value[ 0 ]?.toString().replace('.', ','));
      } else {
        formGroup.get('customPotency').setValue(value[ 0 ]?.toString().replace('.', ','));
        formGroup.get('customPotency').enable();
        formGroup.get('potency').setValue('Otro');
      }
    }
  }

  private setCupsTensionRepin(data: CupsPTData, formGroup: FormGroup): void {
    this.tensionSelected[ formGroup.get('groupIndex').value ] = {
      idTension: data.idTension,
      codigoCRM: data.tensionCodigo,
      nombre: data.tensionDescripcion,
      descripcion: data.tensionDescripcion,
      ciclos: data.ciclos.map(cycle => {
        return {
          idCiclo: cycle.idCiclo,
          codigoCRM: cycle.cicloCodigo,
          nombre: cycle.cicloNombre,
          descripcion: cycle.cicloDescripcion,
          periodos: cycle.periodos.map(period => {
            return {
              idPeriodo: period.idPeriodo,
              codigoCRM: period.periodoCodigo,
              descripcion: period.periodoDescripcion,
              nombre: period.periodoNombre,
              potencias: period.potencias.map(potency => {
                return { valor: potency.potencia };
              })
            };
          })
        };
      })
    };
    this.tensionList[ formGroup.get('groupIndex').value ] = [
      {
        label: this.tensionSelected[ formGroup.get('groupIndex').value ].descripcion,
        value: this.tensionSelected[ formGroup.get('groupIndex').value ].codigoCRM
      }
    ];
    formGroup.get('tension').setValue(this.tensionSelected[ formGroup.get('groupIndex').value ].codigoCRM);
    formGroup.get('tension').disable();
    this.setCupsCycleRepin(data, formGroup);
  }

  private setCupsCycleRepin(data: CupsPTData, formGroup: FormGroup): void {
    this.cycleList[ formGroup.get('groupIndex').value ] = data.ciclos.map(cycle => {
      return { label: cycle.cicloDescripcion, value: cycle.cicloCodigo };
    });
    if (this.cycleList[ formGroup.get('groupIndex').value ].length === 1) {
      this.cycleSelected[ formGroup.get('groupIndex').value ] = {
        idCiclo: this.tensionSelected[ formGroup.get('groupIndex').value ].ciclos[ 0 ].idCiclo,
        codigoCRM: this.tensionSelected[ formGroup.get('groupIndex').value ].ciclos[ 0 ].codigoCRM,
        nombre: this.tensionSelected[ formGroup.get('groupIndex').value ].ciclos[ 0 ].nombre,
        descripcion: this.tensionSelected[ formGroup.get('groupIndex').value ].ciclos[ 0 ].descripcion,
        periodos: this.tensionSelected[ formGroup.get('groupIndex').value ].ciclos[ 0 ].periodos
      };
      formGroup.get('cycle').setValue(this.cycleSelected[ formGroup.get('groupIndex').value ].codigoCRM);
      formGroup.get('cycle').disable();
    } else {
      formGroup.get('cycle').enable();
    }
    this.setCupsPeriodRepin(data, formGroup);
  }

  private setCupsPeriodRepin(data: CupsPTData, formGroup: FormGroup): void {
    if (data.uniquePeriod) {
      this.periodSelected[ formGroup.get('groupIndex').value ] = {
        idPeriodo: this.tensionSelected[ formGroup.get('groupIndex').value ].ciclos[ 0 ].periodos[ 0 ].idPeriodo,
        codigoCRM: this.tensionSelected[ formGroup.get('groupIndex').value ].ciclos[ 0 ].periodos[ 0 ].codigoCRM,
        nombre: this.tensionSelected[ formGroup.get('groupIndex').value ].ciclos[ 0 ].periodos[ 0 ].nombre,
        descripcion: this.tensionSelected[ formGroup.get('groupIndex').value ].ciclos[ 0 ].periodos[ 0 ].descripcion,
        potencias: this.tensionSelected[ formGroup.get('groupIndex').value ].ciclos[ 0 ].periodos[ 0 ].potencias
      };
      this.periodList[ formGroup.get('groupIndex').value ] = [
        {
          label: this.periodSelected[ formGroup.get('groupIndex').value ].descripcion,
          value: this.periodSelected[ formGroup.get('groupIndex').value ].codigoCRM
        }
      ];
      formGroup.get('period').setValue(this.periodSelected[ formGroup.get('groupIndex').value ].codigoCRM);
      formGroup.get('period').disable();
    } else {
      this.periodList[ formGroup.get('groupIndex').value ] = this.cycleSelected[ formGroup.get('groupIndex').value ]?.periodos?.map(period => {
        return { label: period.descripcion, value: period.codigoCRM }
      });
    }
    this.setCupsPotencyRepin(formGroup);
  }

  private setCupsPotencyRepin(formGroup: FormGroup): void {
    if (this.periodSelected[ formGroup.get('groupIndex').value ]) {
      this.potencyList[ formGroup.get('groupIndex').value ] = this.periodSelected[ formGroup.get('groupIndex').value ]?.potencias.map(potency => {
        if (potency.valor === 'Otro') {
          return { label: this.i18NextService.t('NEW_CONTRACTS.OTHER_POTENCY'), value: 'Otro' };
        } else {
          return { label: potency.valor, value: potency.valor };
        }
      });
      const lastPotencyIndex = this.potencyList[ formGroup.get('groupIndex').value ].some(potency => potency.value === 'Otro') ?
        this.potencyList[ formGroup.get('groupIndex').value ].length - 2 :
        this.potencyList[ formGroup.get('groupIndex').value ].length - 1;
      this.minPotency[ formGroup.get('groupIndex').value ] = this.potencyList[ formGroup.get('groupIndex').value ][ lastPotencyIndex ]?.value;
    }
    if (this.potencyList[ formGroup.get('groupIndex').value ]?.length === 1) {
      formGroup.get('potency').setValue(this.periodSelected[ formGroup.get('groupIndex').value ].potencias[ 0 ].valor);
      formGroup.get('potency').disable();
      this.onChangePotency(formGroup, this.periodSelected[ formGroup.get('groupIndex').value ].potencias[ 0 ].valor);
    } else {
      formGroup.get('potency').enable();
    }
    this.enableTensionCyclePeriodPotencyConsumtionRepin(formGroup);
  }

  private enableTensionCyclePeriodPotencyConsumtionRepin(formGroup: FormGroup): void {
    if (!formGroup.get('tension')?.value) {
      formGroup.get('tension')?.enable();
      formGroup.get('tension')?.updateValueAndValidity();
    } else if (!formGroup.get('cycle')?.value) {
      formGroup.get('cycle')?.enable();
      formGroup.get('cycle')?.updateValueAndValidity();
    } else if (!formGroup.get('period')?.value) {
      formGroup.get('period')?.enable();
      formGroup.get('period')?.updateValueAndValidity();
    } else if (!formGroup.get('potency')?.value) {
      formGroup.get('potency')?.enable();
      formGroup.get('potency')?.updateValueAndValidity();
    } else if (!formGroup.get('consumption')?.value) {
      formGroup.get('consumption')?.enable();
      formGroup.get('consumption')?.updateValueAndValidity();
    }
  }

  private resetTensionCyclePeriodPotency(formGroup: FormGroup): void {
    formGroup.get('tension')?.reset();
    formGroup.get('cycle')?.reset();
    formGroup.get('period')?.reset();
    formGroup.get('potency')?.reset();
    formGroup.get('customPotency')?.reset();
    formGroup.get('consumption')?.reset();
    formGroup.get('tension')?.disable();
    formGroup.get('cycle')?.disable();
    formGroup.get('period')?.disable();
    formGroup.get('potency')?.disable();
    formGroup.get('consumption')?.disable();
    this.tensionSelected[ formGroup.get('groupIndex').value ] = null;
    this.cycleSelected[ formGroup.get('groupIndex').value ] = null;
    this.periodSelected[ formGroup.get('groupIndex').value ] = null;
  }
}
